import 'trackjs';
import { getEmbedSearchWidgetIdFromPathname } from '#/modules/embedSearchWidget/utils/getEmbedSearchWidgetIdFromPathname';
import {
  closeRichDetailsSingletonsOnClickOutside,
  initializeRichDetails,
  richDetailsToggled,
  richDetailsTriggeredByHover,
} from '#/snippets/rich-details-snippet';
import {
  richDetailsAttr,
  richDetailsDesktopTriggersOnHoverAttr,
  trackClickedAttr,
} from '#/snippets/snippet-attributes';
import { getTrackClickedDataFromElement } from '#/snippets/track-clicked-snippet';
import { ViewportBreakpoint } from '#/theme/theme';
import { getAnalyticsApplicationContextProps } from '#/utils/analytics/helpers/getAnalyticsApplicationContextProps';
import { registerMixpanelProperties } from '#/utils/analytics/helpers/mixpanel';
import { configureAnalyticsUserData } from '#/utils/analytics/setup/configureAnalyticsUserData';
import { trackClicked } from '#/utils/analytics/track/trackClicked';
import { configureTrackJs } from '#/utils/configureTrackJs';
import { createCookie } from '#/utils/cookies';
import { initXMLHttpRequestActiveCounter } from '#/utils/http/initXMLHttpRequestActiveCounter';
import { trackError } from '#/utils/trackError';
import { trackReferrals } from '#/utils/trackReferral';
import { getViewportBreakpoint } from '#/utils/viewport/getViewportBreakpoint';

export function renderingBootstrapClient() {
  const embedSearchWidgetId = getEmbedSearchWidgetIdFromPathname(
    window.location.pathname,
  );

  registerMixpanelProperties(getAnalyticsApplicationContextProps());

  if (embedSearchWidgetId)
    registerMixpanelProperties({ embed_search_widget_id: embedSearchWidgetId });

  if (window.Idealist.appConstants.debugXhr) {
    initXMLHttpRequestActiveCounter();
  }

  const {
    locale,
    initUserEnvironment: { user, environment },
    errorsBeforeTrackJsInstalled,
    trackErrorBeforeTrackJs,
  } = window.Idealist;

  if (errorsBeforeTrackJsInstalled && trackErrorBeforeTrackJs) {
    errorsBeforeTrackJsInstalled.forEach((error) => trackError(error));
    window.removeEventListener('error', trackErrorBeforeTrackJs);
  }

  // Tracking
  configureTrackJs(user ? user.id : null);
  configureAnalyticsUserData({ user, environment, locale });

  trackReferrals();

  // Scripts
  const isDesktopFn = () => {
    const breakpoint = getViewportBreakpoint();
    return (
      breakpoint === ViewportBreakpoint.md ||
      breakpoint === ViewportBreakpoint.lg
    );
  };
  let isDesktop = isDesktopFn();

  window.addEventListener('resize', () => {
    isDesktop = isDesktopFn();
  });

  document.addEventListener('click', (event) => {
    const { target } = event;
    if (!(target instanceof Element)) return;

    const trackClickedEl = target.closest(`a[${trackClickedAttr}]`);
    if (trackClickedEl instanceof HTMLElement) {
      if (trackClickedEl.hasAttribute(trackClickedAttr)) {
        const data = getTrackClickedDataFromElement(trackClickedEl);
        if (data) {
          trackClicked(data.name, data.properties);
        }
      }
    }

    closeRichDetailsSingletonsOnClickOutside(target);
  });

  document.querySelectorAll('a[data-locale-link]').forEach((el) => {
    el.addEventListener('click', () => {
      const linkLocale = el.getAttribute('data-locale-link')!;
      createCookie('_LOCALE_', linkLocale, 1825);
    });
  });

  document.addEventListener('pointerover', (event) => {
    const { target } = event;
    if (!(target instanceof Element)) return;

    if (isDesktop) {
      const summary = target.closest(
        `details[${richDetailsDesktopTriggersOnHoverAttr}] > summary`,
      );
      if (summary) {
        const details = summary.parentElement;
        if (details instanceof HTMLDetailsElement && !details.open) {
          richDetailsTriggeredByHover(details);
        }
      }
    }
  });

  document.addEventListener(
    'toggle',
    (event) => {
      const { target } = event;

      if (
        target instanceof HTMLDetailsElement &&
        target.hasAttribute(richDetailsAttr)
      ) {
        richDetailsToggled(target);
      }
    },
    true,
  );

  initializeRichDetails();
}
